import { Col, Row } from "antd";
import { ReactNode } from "react";

interface Props {
	children: ReactNode;
	maxWidth?: string | number;
	md?: number;
	xs?: number;
	lg?: number;
	style?: any;
}

const Filter: React.FC<Props> = ({ children, maxWidth = 750, style }) => {
	return (
		<Row
			gutter={[20, 10]}
			style={{ ...style, maxWidth: maxWidth }}
		>
			{children}
		</Row>
	);
};
const FilterMedium: React.FC = ({ children }) => {
	return (
		<Col
			xs={{ span: 24 }}
			md={{ span: 12 }}
		>
			{children}
		</Col>
	);
};
const FilterSmall: React.FC = ({ children }) => {
	return (
		<Col
			xs={{ span: 12 }}
			md={{ span: 6 }}
		>
			{children}
		</Col>
	);
};
const FilterCustom: React.FC<Props> = ({ children, md = 6, xs = 12, lg = 4 }) => {
	return (
		<Col
			xs={{ span: xs }}
			md={{ span: md }}
			lg={{ span: lg }}
		>
			{children}
		</Col>
	);
};
export default Object.assign(Filter, {
	Medium: FilterMedium,
	Small: FilterSmall,
	Custom: FilterCustom,
});
